import { render, staticRenderFns } from "./ReadonlyFormInput.vue?vue&type=template&id=160f7f30"
import script from "./ReadonlyFormInput.vue?vue&type=script&lang=js"
export * from "./ReadonlyFormInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports